import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

export default class ViewProfileCard extends Component {
  getDogImage() {
    const dog = this.props;

    if (dog.image_url && dog.image_url.length > 10) {
      return dog.image_url;
    }

    if (dog.profile_photo && dog.profile_photo.length > 10) {
      return dog.profile_photo;
    }

    return '/images/default_dog.jpg';
  }

  render() {
    const profileLink = `/pooch/${this.props.id}`;

    return (
      <div className={css(styles.container)}>
        <div className={css(styles.content_container)}>
          <div className={css(styles.image_container)}>
            <div className={css(styles.image_wrapper)}>
              <Link to={profileLink}>
                <img className={css(styles.image)} src={this.getDogImage()} alt="Profile" />
              </Link>
            </div>
          </div>
          <div className={css(styles.information_container)}>
            <div className={css(styles.title)}>
              {this.props.name}
            </div>
            {
              this.props.breed ? (
                <div className={css(styles.subtitle)}>
                  {this.props.breed}
                </div>
              ) : false
            }
          </div>
          <div className={css(styles.actions)}>
            <Link className={css(styles.action_link, styles.left_action)} to={profileLink}>
                View
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

ViewProfileCard.defaultProps = {
  name: null,
  breed: null,
};

ViewProfileCard.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string,
  breed: PropTypes.string,
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    display: 'flex',
    width: 360,
    height: 100,
    margin: '20px auto',
    backgroundColor: Theme.white,
    borderRadius: 3,
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',

    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  content_container: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    boxSizing: 'border-box',
    paddingLeft: 20,
    paddingRight: 20,
  },
  image_container: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
  },
  image_wrapper: {
    zIndex: 1,
    width: 60,
    height: 60,
    borderRadius: 30,
    borderWidth: 2,
    borderColor: '#fff',
    borderStyle: 'solid',
    backgroundColor: '#fff',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.3), 0 0 40px rgba(0, 0, 0, 0.1) inset',
    overflow: 'hidden',

    [Theme.mobile_query]: {
      marginRight: 15,
    },
  },
  image: {
    zIndex: -1,
    cursor: 'pointer',
    display: 'block',
    height: '100%',
    width: '100%',
  },
  information_container: {
    flex: 2,
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 20,
    color: Theme.black,
    fontWeight: 'bold',
  },
  subtitle: {
    marginTop: 10,
    fontFamily: Theme.font_family_primary,
    fontSize: 15,
    color: Theme.black,
  },
  actions: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  action_link: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: Theme.font_family_secondary,
    fontSize: 15,
    fontWeight: 'bold',
    height: 40,
    width: 50,
    textTransform: 'uppercase',
  },
  left_action: {
    color: Theme.primary,
    justifyContent: 'flex-end',
    boxSizing: 'content-box',
  },
});



// WEBPACK FOOTER //
// ./src/components/ViewProfileCard/index.js